// extracted by mini-css-extract-plugin
export default {"base":"vp_XZn_n","prepend":"vp_JqHPg","dialCode":"vp_uWFov"};